import { RecordInterviewOutcomeSchema, type RecordInterviewOutcomeRequest } from '@aysar/contracts';
import { useTranslation } from 'react-i18next';

import { DynamicFormModal } from '@/shared/components/dynamic-form/DynamicFormModal/DynamicFormModal';
import { type ModalComponentProps } from '@/shared/components/Modals/modal-registry/modal-registry.types';

import { useRecordInterviewOutcomeModalLogic } from './useRecordInterviewOutcomeModalLogic';

/**
 * What happened at the interview, and the reviewer's private notes.
 *
 * A `DynamicFormModal` on the contract's own schema (W9/U3). Its description
 * states the boundary this dialog is most likely to be misread across:
 * recording an outcome is not deciding the step.
 */
export function RecordInterviewOutcomeModal({ open, onCancel, modalData }: ModalComponentProps) {
  const { t } = useTranslation(['verification', 'common']);
  const view = useRecordInterviewOutcomeModalLogic(modalData, onCancel);

  if (view.caseId === null) {
    return null;
  }

  return (
    <DynamicFormModal<RecordInterviewOutcomeRequest>
      isOpen={open}
      onOpenChange={(next) => {
        if (!next) onCancel();
      }}
      title={t('verification:interview.record.title')}
      description={t('verification:interview.record.subtitle')}
      schema={RecordInterviewOutcomeSchema}
      fields={view.fields}
      initialValues={view.initialValues}
      onSubmit={view.submit}
      onCancel={onCancel}
      submitLabel={t('verification:interview.record.submit')}
      cancelLabel={t('common:action.cancel')}
    />
  );
}
